import type { ReactNode } from 'react'
import { Button } from './Button.js'

interface Props {
  icon?: ReactNode
  title?: string
  description?: ReactNode
  actionLabel?: string
  onAction?: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
  children?: ReactNode
  className?: string
}

export function EmptyPanel({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  children,
  className = '',
}: Props) {
  const hasActions = (actionLabel && onAction) || (secondaryActionLabel && onSecondaryAction)

  return (
    <div className={['cf3-empty-panel', className].filter(Boolean).join(' ')}>
      {icon && (
        <div className='cf3-empty-panel__icon' aria-hidden>
          {icon}
        </div>
      )}
      {title && <p className='cf3-empty-panel__title'>{title}</p>}
      {description && <p className='cf3-empty-panel__desc'>{description}</p>}
      {children}
      {hasActions && (
        <div className='cf3-empty-panel__actions'>
          {actionLabel && onAction && (
            <Button variant='primary' size='sm' onClick={onAction}>
              {actionLabel}
            </Button>
          )}
          {secondaryActionLabel && onSecondaryAction && (
            <Button variant='ghost' size='sm' onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
